<div class="coupon__icon">
    <i class="fa fa-tag"></i>
</div>
<div class="coupon__content">
    <label class="coupon__value">{{coupon.valore}}{{coupon.indicatore_percentuale_assoluto ? '€' : '%'}} SCONTO</label>
    <div class="coupon__add-info">
        <label class="coupon__code mb-0 mr-2">{{coupon.codice}}</label>
        <label class="coupon__estimate mb-0" [ngClass]="{'coupon__estimate--ending': daysRemain < 3}"><i class="fa fa-clock"></i> {{dataFineLbl}}</label>
    </div>
    <label class="coupon__min-importo" [ngClass]="coupon.importo_minimo < totSpesa ? 'coupon__min-importo--valid' : 'coupon__min-importo--invalid'">
        <span *ngIf="coupon.importo_minimo">Spesa minima: {{coupon.importo_minimo | currencyFormat}}</span>
        <span *ngIf="!coupon.importo_minimo">Nessun limite su spesa minima</span>
    </label>
</div>

<img *ngIf="activeCouponCode == coupon.codice" class="coupon__checked-icon" src="/assets/images/checkmark.png">